import { render } from "./consuleFX.vue?vue&type=template&id=58988f80&scoped=true"
import script from "./consuleFX.vue?vue&type=script&lang=js"
export * from "./consuleFX.vue?vue&type=script&lang=js"

import "./consuleFX.vue?vue&type=style&index=0&id=58988f80&lang=scss&scoped=true"

import exportComponent from "/Users/wanggaochao/项目/善城 (2)/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58988f80"]])

export default __exports__